import { useState, useEffect, useRef } from 'react';
import { getColorTier, formatCountdown } from '../utils/formatTime';

/**
 * Hook that provides a live countdown to availableUntil.
 * @param {string|null|undefined} availableUntil - ISO date string
 * @returns {{ days, hours, minutes, seconds, colorTier, isExpired, isPermanent }}
 */
export function useCountdown(availableUntil) {
  const isPermanent = !availableUntil;

  const getState = () => {
    if (isPermanent) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, colorTier: null, isExpired: false, isPermanent: true };
    }
    const ms = new Date(availableUntil).getTime() - Date.now();
    const isExpired = ms <= 0;
    const colorTier = getColorTier(availableUntil);
    const { days, hours, minutes, seconds } = formatCountdown(ms);
    return { days, hours, minutes, seconds, colorTier, isExpired, isPermanent: false };
  };

  const [state, setState] = useState(getState);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isPermanent) return;

    intervalRef.current = setInterval(() => {
      setState(getState());
    }, 1000);

    return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableUntil]);

  return state;
}
